/**
 * Save a file returned by a ts-rest `FileDownloadResponse` route. The fetch
 * client parses csv (`text/*`) responses as a string and xlsx as a Blob —
 * normalize to a Blob before handing it to the browser.
 */
export function saveDownload(body: Blob | string, filename: string): void {
  const blob =
    body instanceof Blob ? body : new Blob([body], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
